/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import _ from 'lodash';
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceItemRoutePageComponent} from '../common/controller/admin-resource-item-route-page.component';
import {AdminResourceContextRoutePageComponent} from '../common/controller/admin-resource-context-route-page.component';
import {getRoutePageComponent, getContextRoutePageComponent} from '../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {adminResourceItemRouteResolve} from '../common/controller/admin-resource-routing';
import {ReportTranslationCopyModalComponent} from './report-translation-copy-modal.component';
import {ReportTranslationResource} from '../../components/api/resources/resource/report-translation.resource';

export function reportTranslationStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('report-translations.report-translation', ReportTranslationResource, 'app.rep', 'app');
    
        $stateProvider.state(rh.listPath(), rh.list({
          views: {
            'content@app': { component: getRoutePageComponent('report-translation-route') }
          }
        }));
    
        $stateProvider.state(rh.newItemPath(), rh.newItem());
    
        $stateProvider.state(rh.itemPath(), rh.modelCommsItem({
          resolve: _.merge({}, adminResourceItemRouteResolve('report-translation-edit', 'edit'), {
            copyConfig: function() {
              return {
                modalComponent: ReportTranslationCopyModalComponent,
                stateUrl: 'app.rep.report-translations.report-translation',
                lcase: 'reportTranslation',
                ucase: 'ReportTranslation'
              };
            }
          }),
            views: {
            'content@app': { component: AdminResourceItemRoutePageComponent, bindings: { item: 'adminResourceItemKey', variant: 'adminResourceItemVariant' }  },
            'context@app': {component: AdminResourceContextRoutePageComponent}
          }
        }, 'ReportTranslation'));
  }, adnRouterHelper);
}
